import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ColumnDef,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  PaginationState,
  Row,
  SortingState,
  useReactTable,
} from '@tanstack/react-table';

import { DataTable } from '@/components/table/data-table';
import type { Simulation } from '@/routes/(app)/(scenarios)/types';

interface SimulationsTableProps {
  simulations: Array<Simulation>;
  onClickRow: (row: Row<Simulation>) => void;
}
const SimulationsTable: FC<SimulationsTableProps> = ({
  simulations,
  onClickRow,
}) => {
  const { t } = useTranslation();
  const [sorting, setSorting] = useState<SortingState>([]);
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });
  const columns: Array<ColumnDef<Simulation>> = [
    {
      header: t('simulations.table.run'),
      cell: ({ row }) => (
        <p className='font-mono'>
          {t('simulations.table.runNumber', { number: row.index + 1 })}
        </p>
      ),
    },
  ];
  const table = useReactTable<Simulation>({
    state: {
      pagination,
      sorting,
    },
    getRowId: (row) => row.simulation_run_id,
    data: simulations,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    onSortingChange: setSorting,
    getPaginationRowModel: getPaginationRowModel(),
    onPaginationChange: setPagination,
    pageCount: Math.ceil(simulations.length / pagination.pageSize),
  });
  return (
    <DataTable
      table={table}
      onRowClick={onClickRow}
    />
  );
};
export default SimulationsTable;
